import { render, staticRenderFns } from "./StaticPage.vue?vue&type=template&id=58fdc412&scoped=true&"
import script from "./StaticPage.vue?vue&type=script&lang=js&"
export * from "./StaticPage.vue?vue&type=script&lang=js&"
import style0 from "./StaticPage.vue?vue&type=style&index=0&id=58fdc412&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fdc412",
  null
  
)

export default component.exports